import { useEffect, useState } from 'react';
import { getTextVisitEligibleStatus } from 'api/textVisit';

interface EligibleStatus {
    eligible: boolean;
    completedScriptSureOnboarding: boolean;
    status: 'PENDING' | 'APPROVED' | 'REJECT' | 'PAUSE';
}

export default function useGetEligibleStatus(): [EligibleStatus | undefined, boolean, () => void] {
    const [loading, setLoading] = useState(false);
    const [eligibleStatus, setEligibleStatus] = useState<EligibleStatus>();

    const fetchData = async () => {
        try {
            setLoading(true);
            const result = await getTextVisitEligibleStatus();
            if (!result.error) {
                setEligibleStatus(result?.data?.data);
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchData();
    }, []);

    return [eligibleStatus, loading, fetchData];
}
